import './App.css';
import Weather from "./Weather"

export default function App() {
  return (
    <div className="App">
      <div className="container">
      <Weather defaultCity= "Paris" />
      <footer>
        This project is created by <a href="https://github.com/mozhganpe66/">Mozhgan</a> and open sourced in <a href="https://github.com/mozhganpe66/react-weather-app">Github</a> 
      </footer>
      </div>
    </div>
  );
}


